module.exports = __webpack_public_path__ + "img/bug05.324a5943.jpg";